// extracted by mini-css-extract-plugin
export default {"ambientalL1":"AmbientalL1_ambientalL1__vvlYe","smallPiegraph":"AmbientalL1_smallPiegraph__81FuE"};